import React from 'react'
import { Route, IndexRoute } from 'react-router'

import Container from './containers/Container'
import connectListContainer from '../shared/connectors/ListContainer'
import DetailsContainer from './containers/DetailsContainer'

import getPath from '../../shared/utils/getPath'

const guidedTourRoutes = (
  <Route
    component={Container}
    key="guided-tour-routes"
    path={getPath('frontend', 'guided-tour')}
  >
    <IndexRoute component={connectListContainer('guidedTour')} />
    <Route
      path={getPath('frontend', 'guided-tour', ':id')}
      component={DetailsContainer}
    />
  </Route>
)

export default guidedTourRoutes



// WEBPACK FOOTER //
// ./src/frontend/guided-tour/routes.js